<template>
  <el-card shadow="never" class="container" :body-style="{ 'min-height':'600px'}">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/personal/shenbao'}">申报实验</el-breadcrumb-item>
      <el-breadcrumb-item>实验列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="text-align:right">
      <el-button type="primary" class="el-icon-plus" size="small" @click="handleAdd">新 增</el-button>
    </div>
    <el-table :data="data" style="width: 100%">
      <el-table-column type="expand">
        <template slot-scope="props">
          <p class="ql-editor" v-html="props.row.synopsis"></p>
        </template>
      </el-table-column>
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="title" label="实验名称"></el-table-column>
      <el-table-column prop="status" label="实验状态" width="150">
        <template slot-scope="{row}">
          <el-tag
            size="small"
            :type="row.status==0?'info':row.status==1?'success':'danger'"
          >{{row.status==0?'未发布':row.status==1?'进行中':'已结束'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-button @click="handKnowledge(scope.row)" type="text" size="small">知识点管理</el-button>
          <el-button @click="handEdit(scope.row)" type="text" size="small">编辑</el-button>
          <el-button type="text" size="small" @click="handDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      prev-text="上一页"
      next-text="下一页"
      layout="total, prev, pager, next, jumper"
      :total="page.total"
      :current-page="page.page"
      :page-size="page.size"
      :pager-count="page.pagerCount"
      @current-change="handPageChange"
      style="margin-top:15px"
    ></el-pagination>

    <el-dialog
      width="600px"
      :title="`${form.id ? '编辑' : '添加'}实验项目`"
      :visible.sync="visible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :rules="rules" :model="form" label-width="110px">
        <el-form-item label="实验名称" prop="title">
          <el-input v-model="form.title" placeholder="请设置实验名称（20 字以内）"></el-input>
        </el-form-item>
        <el-form-item label="实验项目" prop="expUid">
          <el-cascader
            class="dialog-cascader"
            style="width: 100%;"
            v-model="form.expUid"
            placeholder="请选择实验项目"
            :options="expList"
            :props="{
                            value: 'uid',
                            label: 'name',
                        }"
            clearable
            filterable
            @change="handChange"
            :disabled="flag"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="项目名称" prop="expName" v-show="false">
          <el-input v-model="form.expName"></el-input>
        </el-form-item>
        <el-form-item label="选择报告模版" prop="expReportMouldvId">
          <el-select
            v-model="form.expReportMouldId"
            style="width: 100%;"
            clearable
            placeholder="请选择"
            :disabled="flag"
          >
            <el-option v-for="item in moudles" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实验简介" prop="synopsis">
          <vue2editor v-model="form.synopsis" @onchange="onchange"></vue2editor>
        </el-form-item>
        <el-form-item label="评分权重" prop="weight">
          <el-row style="text-align:center">
            <el-col :span="7">
              <el-tag>{{`报告占比${form.weight*100}%`}}</el-tag>
            </el-col>
            <el-col :span="10">
              <el-slider v-model="form.weight" :max="1" :min="0" :step="0.1" :show-tooltip="false"></el-slider>
            </el-col>
            <el-col :span="7">
              <el-tag>{{`实验占比${100-form.weight*100}%`}}</el-tag>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="发布状态" prop="status">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="dataFormSubmit()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog width="960px" title="知识点管理" :visible.sync="open" :close-on-click-modal="false">
      <el-dialog
        width="30%"
        title="编辑知识点"
        :visible.sync="innerVisible"
        append-to-body
        :destroy-on-close="true"
      >
        <el-form :model="knowledgeForm" ref="knowledgeForm">
          <el-form-item
            label="知识点名称"
            prop="pointName"
            :rules="{required: true, message: '知识点名称不能为空', trigger: 'blur'}"
          >
            <el-input v-model="knowledgeForm.pointName"></el-input>
          </el-form-item>
          <el-form-item
            label="软件key"
            prop="pointKey"
            :rules="{required: true, message: '软件key不能为空', trigger: 'blur'}"
          >
            <el-input v-model="knowledgeForm.pointKey"></el-input>
          </el-form-item>
          <el-form-item label="知识点权重">
            <el-tag type="warning">{{`知识点权重${knowledgeForm.weight*100}%`}}</el-tag>
            <el-slider
              v-model="knowledgeForm.weight"
              :max="1"
              :min="0"
              :step="0.1"
              :show-tooltip="false"
            ></el-slider>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false">取 消</el-button>
          <el-button type="primary" @click="sbumitKnowForm(knowledgeForm)">确 定</el-button>
        </span>
      </el-dialog>
      <div class="text-r">
        <el-button type="primary" @click="addKnowledge">新增知识点</el-button>
      </div>
      <el-table :data="knowData" style="width: 100%">
        <el-table-column prop="pointName" label="知识点名称"></el-table-column>
        <el-table-column prop="pointKey" label="软件key"></el-table-column>
        <el-table-column prop="weight" label="知识点权重">
          <template slot-scope="{row}">
            <el-tag type="warning">{{`知识点权重${row.weight*100}%`}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button type="primary" style="margin-right:6px" @click="KnowEdit(row.id)">编辑</el-button>
            <el-popconfirm title="请确认是否删除该知识点!" @onConfirm="removeKnowledge(row.id)">
              <el-button slot="reference" type="danger">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </el-card>
</template>
<script>
import { getList, add, update, getEntity } from "@/api/shenbao/shenbao-exp";
import { selectExpList } from "@/api/exp/experiment";
import { remove } from "@/api/lab/experiment";
import { query as templateQuery } from "@/api/lab/experimentreportmould";
import { mapGetters } from "vuex";
import {
  addKnowledge,
  removeByID,
  getByID,
  updateKnowledge,
  getByQuery
} from "@/api/shenbao/shenbao-knowledge";
import vue2editor from "@/components/common/vue2editor";
import "quill/dist/quill.snow.css";

export default {
  data() {
    return {
      shenbaoExpId: null,
      flag: false,
      knowData: [],
      knowledgeForm: {},
      form: {},
      visible: false,
      innerVisible: false,
      open: false,
      expList: [],
      moudles: [],
      data: [],
      page: {
        page: 1,
        size: 5,
        total: 0
      },
      tempPage: {
        page: 1,
        limit: 100,
        total: 0
      },
      rules: {
        title: [
          { required: true, message: "此项必填", trigger: "blur" },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: "blur" }
        ],
        expUid: [
          { required: true, message: "实验项目不能为空", trigger: "blur" }
        ],
        synopsis: [
          { required: true, message: "实验简介不能为空", trigger: "blur" }
        ]
      }
    };
  },
  components: {
    vue2editor
  },
  created() {
    this.getQueryList();
    this.getTemplateQuery();
    selectExpList().then(res => {
      this.expList = res;
    });
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    handChange(val) {
      this.expList.map(item => {
        if (item.uid == val[0]) {
          item.children.map(k => {
            if (k.uid == val[1]) {
              this.$set(this.form, "expName", k.name);
            }
          });
        }
      });
    },
    onchange(txt) {
      this.$set(this.form, "synopsis", txt);
    },
    KnowEdit(id) {
      //编辑知识点
      getByID(id).then(res => {
        this.knowledgeForm = res;
        this.innerVisible = true;
      });
    },
    addKnowledge() {
      //新增知识点
      this.innerVisible = true;
      this.knowledgeForm = {
        pointName: "",
        pointKey: "",
        weight: 1
      };
    },
    removeKnowledge(id) {
      //删除知识点
      removeByID(id).then(() => {
        this.getByQuery(this.shenbaoExpId);
        this.$message.success("操作成功!");
      });
    },
    sbumitKnowForm() {
      //知识点提交
      this.$refs["knowledgeForm"].validate(valid => {
        if (valid) {
          let opFun = this.knowledgeForm.id ? updateKnowledge : addKnowledge;
          Object.assign(this.knowledgeForm, {
            shenbaoExpId: this.shenbaoExpId
          });
          opFun(this.knowledgeForm).then(() => {
            this.getByQuery(this.shenbaoExpId);
            this.$message.success("操作成功!");
          });
        } else return false;
      });
    },
    getByQuery(shenbaoExpId) {
      let params = {
        shenbaoExpId
      };
      getByQuery(1, 100, params).then(res => {
        this.knowData = res.list;
        this.innerVisible = false;
      });
    },
    handKnowledge(row) {
      //开知识点弹窗
      this.open = true;
      this.shenbaoExpId = row.id;
      this.getByQuery(this.shenbaoExpId);
    },
    getTemplateQuery() {
      //获取报告模版列表(分页)
      const { page, limit } = this.tempPage;
      const { userInfo } = this;
      templateQuery(page, limit, { createUser: userInfo.id }).then(res => {
        const { totalCount, list } = res;
        this.$set(this.tempPage, "total", totalCount);
        this.moudles = list;
      });
    },
    handleAdd() {
      this.form = {
        weight: 1,
        status: 0
      };
      this.flag = false;
      this.visible = true;
    },
    handDelete(row) {
      this.$confirm("此操作将删除该选项, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          remove([row.labExpUid]).then(() => {
            this.$message.success("删除成功!");
            this.getQueryList();
          });
        })
        .catch(() => {});
    },
    handPageChange(page) {
      this.$set(this.page, "page", page);
      this.getQueryList();
    },
    getQueryList() {
      const { page, size } = this.page;
      const { id } = this.$route.params;
      getList(page, size, { shenbaoId: id }).then(res => {
        const { totalCount, list } = res;
        this.$set(this.page, "total", totalCount);
        this.data = list;
      });
    },
    dataFormSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let opFun = this.form.id ? update : add;
          let expUid = this.form.expUid;
          if (expUid instanceof Array) {
            expUid = expUid[expUid.length - 1];
          }
          Object.assign(this.form, {
            shenbaoId: this.$route.params.id,
            expUid
          });
          opFun(this.form).then(() => {
            this.visible = false;
            this.getQueryList();
            this.$message.success("操作成功");
          });
        } else return false;
      });
    },
    handEdit(row) {
      getEntity(row.id).then(res => {
        this.flag = true;
        this.form = res;
        this.visible = true;
      });
    }
  }
};
</script>
<style lang="less">
</style>
